import { askConfirmation } from 'components/common/Confirm';
import RecordAction from '../RecordAction';
import AhaAnalytics from 'javascripts/analytics';

export class DeleteConnectedPageAction extends RecordAction {
  recordTypes = ['ConnectedPage'];
  menuItemType = 'danger' as const;

  get title() {
    const compatibleItems = this.selectedRecords.filter(r =>
      this.showForRecord(r)
    );
    if (compatibleItems.length > 1) {
      return `Stop collaborating on ${compatibleItems.length} documents`;
    }
    return `Remove shared document`;
  }

  showForSelectedRecords() {
    return this.selectedRecords.every(record => this.showForRecord(record));
  }

  async runForRecords(records) {
    let prompt: string;
    if (records.length === 1) {
      const name = records[0].name;
      prompt = `Are you sure you want to stop collaborating on ${name}?`;
    } else {
      prompt = `Are you sure you want to stop collaborating on ${records.length} shared documents?`;
    }

    if (await askConfirmation({ body: prompt })) {
      for (const record of records) {
        const type =
          record.documentType === 'WHITEBOARD' ? 'Whiteboard' : 'Note';
        await record.destroy({ args: { __reactivelyUpdate: true } });

        AhaAnalytics.track(
          'Feature-7041995707037045997',
          'Recipient removes note from list',
          {
            'Document type': type,
          }
        );
      }
    }
  }
}
